











































































import { mapMutations } from 'vuex'
import { $, sleep, stringToCodePoints } from '@/utils/helpers'
import * as qs from 'qs'
import AmataList from '@/components/AmataList.vue'
import AmataListItem from '@/components/AmataListItem.vue'
import UserActionMixin from '@/mixins/UserActionMixin'
import Vue from 'vue'

export default Vue.extend({
  name: 'CallWaitingSetting',
  components: {
    AmataList,
    AmataListItem
  },
  mixins: [UserActionMixin],
  data() {
    return {
      currentIsVideoWaiting: this.$store.getters['CallSetting/isVideoWaiting'] || 0,
      currentIsVoiceWaiting: this.$store.getters['CallSetting/isVoiceWaiting'] || 0,
      currentIsNozokiWaiting: this.$store.getters['CallSetting/isNozokiWaiting'] || 0,
      icon: 'plus-circle',
      isAllCheck: 0,
      isDirectChangePossibleTime: false,
      isOpen: false,
      possibleTimes: [],
      timeGroups: [],
      initialized: false
    }
  },
  computed: {
    myGender(): string {
      return this.$store.getters['MyData/myGender']
    },

    /**
     * アピールコメントの長さ
     */
    appealCommentLength(this: any): number {
      return stringToCodePoints(this.appealComment).length
    },

    /**
     * 通話が許可されていない
     */
    isNotPermittedCall(this: any): boolean {
      return (
        !this.currentIsVoiceWaiting && !this.currentIsVideoWaiting && !this.currentIsNozokiWaiting
      )
    }
  },
  watch: {
    async isOpen(val: boolean) {
      if (val) {
        this.icon = 'minus-circle'
        await sleep(0)
        $('.CallWaitingSetting__scroll-target').scrollIntoView()
      } else {
        this.icon = 'plus-circle'
      }
    }
  },
  async created() {
    await this.fetchData({
      page: 'get_init'
    })
    this.timeGroups = [
      [0, 1, 2],
      [3, 4, 5],
      [6, 7, 8],
      [9, 10, 11],
      [12, 13, 14],
      [15, 16, 17],
      [18, 19, 20],
      [21, 22, 23]
    ]
    this.initialized = true
  },
  methods: {
    ...mapMutations('CallSetting', [
      'setIsVideoWaiting',
      'setIsVoiceWaiting',
      'setIsNozokiWaiting'
    ]),

    fetchData(this: any, params: any): Promise<any> {
      return new Promise(async resolve => {
        try {
          const res = await this.$http.post('/call_setting.php', qs.stringify(params))
          if (res.data.error) {
            throw new Error(res.data.error)
          } else {
            this.possibleTimes = res.data.possible_times
            this.currentIsVideoWaiting = res.data.video_waiting
            this.currentIsVoiceWaiting = res.data.voice_waiting
            this.currentIsNozokiWaiting = res.data.nozoki_waiting
            this.setIsVideoWaiting(this.currentIsVideoWaiting)
            this.setIsVoiceWaiting(this.currentIsVoiceWaiting)
            this.setIsNozokiWaiting(this.currentIsNozokiWaiting)
          }
          resolve(res.data)
          this.checkIsAllCheck()
        } catch (err) {
          console.error(err)
        }
      })
    },

    /**
     * 保存
     */
    async save(this: any) {
      if (!this.checkApp()) {
        return
      }

      try {
        const res = await this.$http.post(
          '/call_setting/',
          qs.stringify({
            page: 'save',
            possible_times: this.possibleTimes,
            video_waiting: this.currentIsVideoWaiting,
            voice_waiting: this.currentIsVoiceWaiting,
            nozoki_waiting: this.currentIsNozokiWaiting
          })
        )
        if (res.data.error) {
          if (res.data.error.code && res.data.error.code === 20) {
            this.$_ageAuth(res.data.error)
          } else {
            throw new Error(res.data.error)
          }
        } else {
          this.setIsVideoWaiting(this.currentIsVideoWaiting)
          this.setIsVoiceWaiting(this.currentIsVoiceWaiting)
          this.setIsNozokiWaiting(this.currentIsNozokiWaiting)
          this.$router.back()
        }
      } catch (err) {
        this.$_alert(err)
      }
    },

    /**
     * isAllCheck の値が直接変更されたら全ての値を変更する
     */
    handleAllCheckInput() {
      if (!this.checkApp()) {
        return
      }

      for (let i = 0; i < 24; i++) {
        this.possibleTimes[i] = this.isAllCheck
      }
      this.checkIsAllCheck()
    },

    /**
     * 時間のチェックが変更された
     */
    changePossibleTimes() {
      if (!this.checkApp()) {
        return
      }
      this.checkIsAllCheck()
    },

    /**
     * 全ての時間がチェックされているかチェック
     */
    checkIsAllCheck() {
      if (this.possibleTimes.every(elem => elem === 1)) {
        this.isAllCheck = 1
      } else {
        this.isAllCheck = 0
      }
    },

    /**
     * アプリかどうかチェックし、アプリじゃなければダウンロードページに遷移
     */
    checkApp(this: any): boolean {
      // アプリじゃなければダウンロードページに(data fetch が終わっていないとページにアクセスするだけでアプリを起動しようとしてしまう)
      if (this.$_hasCordova || !this.initialized) {
        return true
      }
      this.$_tryLaunchApp('home')
      return false
    }
  }
})
